import {useState, useEffect} from 'react'
import {isEmpty} from 'lodash'
import {backendGetRequest} from '../../common/utils/requests'

export function useQueryApiV2<T>({
  path,
  params,
  skip,
}: {
  path: string
  params?: Record<string, any>
  skip?: boolean
}): [T | null, {loading: boolean; error: Error | null}] {
  const [error, setError] = useState<Error | null>(null)
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState<T | null>(null)
  const paramsString = isEmpty(params) ? '' : new URLSearchParams(params).toString()

  useEffect(() => {
    if (skip) return

    const url = paramsString ? `/api/v2${path}?${paramsString}` : `/api/v2${path}`
    backendGetRequest(url, true)
      .then((res) => {
        if (res.ok) return res.json()
        throw new Error(`Failed to query apiV2 ${res.status} ${res.statusText}. Path: ${path}`)
      })
      .then((resData) => {
        setData(resData)
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e)
        setError(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [path, paramsString, skip])

  return [data, {loading, error}]
}
